import { ProjectViewModel } from "./ProjectModel";

export interface ISignatureInputModel {
  MemberId: number
  SignatureId: number
  SignatureName: string
  SignatureText: string
  IsActive: boolean
}
export interface ISignatureListInputModel {
  MemberId: number | undefined

}

export interface ISignatureOutputModel {
  MemberId: number
  SignatureId: number
  SignatureName: string
  SignatureText: string
  MemberName: string
}
export interface IMessageGroupMGInputModel {
  MemberId: number
  OwnerId: number
  GroupId: number
  MessageGroupId?: number
  ProjectId: number
  GroupDescription: string
  IsActive: boolean
  MessageGroupMembers: IMessageGroupMemberInputModel[]
}

export interface IMessageGroupMemberInputModel {
  MemberId: number
  UserId: number
  MessageGroupId: number
  GroupId: number
  ProjectId: number
  RoleId: number
  ReceiverType: number
  IsActive: boolean
}

export interface IMessageGroupOutputModel {
  groupId: number
  groupDescription: string
  memberId: number
  memberName: string
  receiverType: number
}
export interface IMessageGroupListInputModel {
  MemberId: number
  ProjectId: number
}

export interface IMessageGroupModel {
  value: string
  text: string
  selected: boolean
  selectMode: string
  memberList: IMessageGroupModel[] | null
}
export interface IMessageGroupMemberListModel {
  MemberId: number
  MemberName: string
}

export interface IMessageGroupListModel {
  value: number
  title: string
  isGroup: boolean
  isActive: boolean
  groupId: number
  groupName: string
}

export interface IMessageInputModel {
  CanSendMail: boolean
  MemberId: number
  MessageId?: number
  ProjectId: number
  GroupId?: number
  DisciplineId: number
  ParentMessageId: number
  MessageType: number
  HasAttachments: boolean
  IsConfidential: boolean
  MessageCategory: number
  MessageSubject: string
  MessageBody: string
  ResponseType: number
  RespondOn?: string | null
  MessageNo: string
  IssueReason: number
  MsgSerialNo: number
  SentOn?: string | null
  elementDetails?: IMsgElementInputModel[]
  documentAttachments: IMsgDocumentInputModel[]
  messageAttachments: IMsgAttachmentInputModel[]
  messageReceivers: IMsgReceiverInputModel[],
  CurrentProjectDetails?: ProjectViewModel
}

export interface IMsgSLNoInputModel {
  projectId: number
  groupId: number
  moduleId: number
  elementDetails?: IMsgElementInputModel[]
}

export interface IMsgElementInputModel {
  deId: number
  deDescription: string
  dedId: number
  dedDescription: string
  dedShortDescription: string
  sortBy: number
}

export interface IMsgDocumentInputModel {
  memberId: number
  messageId: number
  docId: number
  revisionNo: string
  response: number
  responseRemarks: string | null
  isActive: boolean
}

export interface IMsgAttachmentInputModel {
  memberId: number,
  messageId: number
  attachedMessageId: number
  isActive: boolean
}

export interface IMsgReceiverInputModel {
  memberId: number
  messageId: number
  receiverType: number
  receiverGroup: number
  responseDate?: string | null
  sortBy?: number | null
  faxCopy?: boolean | null
  hardCopy?: boolean | null
  isDeleted: boolean
  isRead?: string
  readOn?: string | null
  userId: number
  isActive: boolean
}

export interface IMsgListInputModel {
  transType: string
  projectId: number
  groupId: number
  memberId: number
  mailBoxType?: number | null
  isConfidential?: boolean | null
  sentType?: string | null
  sentFrom?: Date | null
  sentTo?: Date | null
  messageId?: number | null
  messageNo?: string | null
  messageNoSearchText?: string | null,
  messageSubjectSearchText?: string | null
}

export interface IMessageSearchInputModel {
  projectId: number
  memberId: number
  searchId: number
  searchName: string
  messageNo: string
  messageSubject: string
  searchText: string
}
export interface IMessageSearchModel {
  searchId: number
  searchName: string
  messageNo: string
  messageSubject: string
  searchText: string
}
export interface IMessageDocumentModel {
  messageId: number
  docId: number
  documentNo: string
  title: string
  revision: string
  revisedOn: Date
  createdBy: string
  authorisedBy: string
}
export interface IMessageAttachmentModel {
  messageId: number
  attachedMessageId: number
  fromMemberId: number
  toMemberId: number
  fromMemberName: string
  toMemberName: string
  messageBody: string
  messageSubject: string
}
export interface IMessageDetailModel {
  messageId?: number
  disciplineId?: number
  discipline?: string
  messageType: number
  messageTypeDesc?: string
  hasAttachments: boolean
  messageCategory: number
  messageSubject: string
  messageBody: string
  parentMessageId: number
  responseType?: number
  respondOn?: Date
  messageNumber?: string
  issueReason?: number
  messageSerialNumber?: number
  sentOn?: Date
  createdOn?: Date
  from?: string
  fromMemID: number
  registeredBy: number
  messageTypeShortDesc: string
  respondByDesc: string
  issueDescription: string
  custRefNo: string
  preparedBy: string
}

export interface IMessageStatusLogModel {
  messageId: number
  messageNumber: string
  messageSubject: string
  messageBody: string
  sentOn?: Date
  isConfidential: boolean
  respondOn?: Date
  receiverType: string
  memberName: string
  readOn?: Date
  responseDate?: Date
}

export interface IMsgHistoryInputModel {
  projectId: number
  groupId: number
  messageId: number
  memberId: number
  roleId?: number
}

export interface IMsgHistoryOutputModel {
  messageId: number
  messageNumber: string
  messageSubject: string
  messageBody: string
  messageCategory: number
  sentOn: Date
  isConfidential: boolean
  status: string
  statusCode: string
  respondOn: Date
  responseDate: Date
  from: string
  to: string
  cc: string
  fromGroupName: string
  fromGroupShortName: string
}

export interface IMsgReceiverStatus {
  messageId: number
  memberId: number
  isRead?: string
  readOn?: Date
  responseDate?: Date | null
  userId: number
}

export interface MessageReceiverOutputModel {
  messageId: number
  receiverType: number
  receiverGroup: number
  receiverGroupName?: string
  memberId: number
  memberName: string
}

export interface IMsgDocumentAttachmentModel {
  fileId: number
  fileName: string,
  fileExtension: string,
  fileSize: number
}

export interface IMsgAttachmentsModel {
  msgId: number,
  projectId: number,
  messageDocuments: IMsgDocumentAttachmentModel[],
  createdBy: number
}

export interface ICommunicationInputModel {
  Trans_Type: string,
  Project_Id: number,
  Group_Id: number,
  Proj_Code: string
}
export interface ICommunicationProtocol {
  psno: string,
  staff_name: string,
  designation: string,
  uid: string,
  mail_id: string;
  email: string,
  mobile: string,
  role_desc: string,
  disc_Description: string,
  scope_of_work: string,
  scope: string,
  proj_Code: string,
  name: string,
  Reference_Id: string,
  reference_Id: number,
  member_Code: string,
  member_Desc: string,
  proj_Description: string,
  member_Type_Code: string,
  member_Type_Desc: string,
  member_Id: string,
  coordinator: string,
  coord: string
  projectId: number
  groupId: number
}





